export default __webpack_public_path__ + "static/media/bleibemobil-Logo-quer-neg.b7736738.png";